import React, { useState, useEffect } from "react";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import CrossIcon from "../../common/assests/croosicon.png";
import ImageUploader from "../../common/imguploader/ImageUploader";
import { Avatar, AvatarGroup, InputAdornment, TextField } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import "./PushNotification.css";
import CustomBtn from "../../common/customButton/CustomBtn";
import Paginations from "../../common/pagination/Paginations";
import UserImg from "../../common/assests/sampleuser.svg";
import { allUserListApi } from "../../api";
import { useSelector } from "react-redux";
import SearchItem from "../../common/assests/search.svg";
import dayjs from "dayjs";
import configuration from "../../config/Config";

const NotificationModal = ({ open, onClose, onSave,editingData }) => {
  const token = useSelector((state) => state?.user?.user?.token);
  const [userList, setUserList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState();
  const [loading, setLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [myTimout, setMyTimeOut] = useState();
  const [totalUser, setTotalUser] = useState(0);
  const [value, setValue] = useState("");
  const [sendTo, setSendTo] = useState(1);
  const [notificationDate, setNotificationDate] = useState(null);
  const [time, setTime] = useState("");
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [picture, setPicture] = useState(null);
  const [selectedType1, setSelectedType1] = useState("Notification");
  const [selectedType, setSelectedType] = useState("All Users");
  const [selctUserModal, setSelctUserModal] = useState(false);
  const [selectedIds, setSelectedIds] = useState([]);
  const [shouldFetchUsers, setShouldFetchUsers] = useState(false);


  useEffect(() => {
    if (editingData) {
      // For editing, initialize values based on editing data
      setSendTo(editingData.sendTo === "Users" ? 1 : 2);
      setTime(editingData?.notificationTime || null);
      setNotificationDate(editingData.notificationDate ? dayjs(editingData.notificationDate) : null);
      setTitle(editingData.title || "");
      setDescription(editingData.description || "");
      setPicture(editingData.notificationPicture || null);
      setSelectedType1(editingData.notificationType || "Notification");
  
      if (editingData.notificationType === "Email") {
        // Reset fields for email notifications
        setTitle(""); 
        setDescription("");
        setValue(editingData?.description || ""); 
      }
  
      setSelectedType(editingData.sendNotification || "All Users");
      setSelectedIds(editingData.recipients || []);
    } else {
      // Reset for creating a new notification
      setSendTo(1);
      setNotificationDate(null);
      setTime("");
      setTitle("");
      setDescription("");
      setPicture(null);
      setSelectedType1("Notification");
      setSelectedType("All Users");
      setSelectedIds([]);
      setValue(""); 
    }
  }, [editingData]);
  
  
  const handleAllUserList = async () => {
    try {
      // User = 1, Seller = 2
      let type = sendTo === 1 ? 1 : 2; 
      setLoading(true);
      const response = await allUserListApi({
        token,
        currentPage,
        type,
        searchQuery,
      });
      setTotalUser(response?.totalUsers);
      setUserList(response?.users || []);  // Or sellers depending on `sendTo`
      setCurrentPage(response?.currentPage);
      setTotalPages(response?.totalPages);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log("error", error);
    } finally {
      setLoading(false);
    }
  };


   // Only fetch when `shouldFetchUsers` is true
  useEffect(() => {
    if (shouldFetchUsers) {
      handleAllUserList();
    }
  }, [shouldFetchUsers,currentPage]); 


  useEffect(() => {
  if (searchQuery.trim() == "") {
    if (shouldFetchUsers) {
    handleAllUserList();
    }
  } else {
 
    clearTimeout(myTimout);
    const timeout = setTimeout(() => handleAllUserList(), 500);
    setMyTimeOut(timeout);
  
    // Cleanup on unmount or re-render
    return () => clearTimeout(timeout);
  }
}, [searchQuery])



  const handleSendToChange = (e) => {
    const value = e.target.value;
     //  "User" to 1, "Vendor" to 2
    const mappedValue = value === "User" ? 1 : 2;
    setSendTo(mappedValue);
  };


  const handleCloseSelectedUserModal = () => {
    // setCloseSelectedUserModal()
    setSelctUserModal(false);
    setShouldFetchUsers(false);
  };

  const handleSelectUserModal = () => {
    setSelctUserModal(true);
    setShouldFetchUsers(true);
    setCurrentPage(1)
    setTotalPages(0)
  };

  const handleImageUpload = (uploadedImage) => {
    setPicture(uploadedImage);
  };

  const toggleUserSelection = (userId) => {
    setSelectedIds((prevSelectedIds) =>
      prevSelectedIds.includes(userId)
    // Remove if already selected
        ? prevSelectedIds.filter((id) => id !== userId) 
        // Add if not already selected
        : [...prevSelectedIds, userId] 
    );
  };

  const handleAddUsers = () => {
    // Ensure selectedIds only contains unique IDs
    // Removes duplicates 
    const uniqueSelectedIds = Array.from(new Set(selectedIds)); 
    // Update state (if needed, for persistence beyond modal close)
    setSelectedIds(uniqueSelectedIds);
    setSelctUserModal(false);
};


const getPlainText = (html) => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, "text/html");
  return doc.body.textContent || "";
};

  const handleSave = () => {
    // const plainTextDescription = getPlainText(value);

    // let finalTitle = title;
    // let finalDescription = description;

    // if (selectedType1 === "Email") {
    //   finalTitle = "Email Notification";

    //   finalDescription = value;
    // }

    const plainTextDescription = getPlainText(value); 
  
    let finalTitle = title;
    let finalDescription = description;
  
    if (selectedType1 === "Email") {
      finalTitle = "Email Notification";
      finalDescription = plainTextDescription; 
    }

    const formData = {
      sendTo,
      notificationDate,
      time,
      title: finalTitle,
      description: finalDescription,
      picture,
      selectedType1,
      selectedType,
       recipients: selectedIds
    };
   onSave(formData)
  };

  const handlePageChange = (page) => {
    // setLoading(true);
    setCurrentPage(page);
  };



  return (
    <>
      <Modal
        open={open}
        onClose={onClose}
        sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}
      >
        <Box className="createNotificationModal1">
          <Box className="notificationModal1Header">
            <Typography className="notificationModal1Title">
            {editingData ? "Edit Notification" : "Create New Notification"}
            </Typography>
            <IconButton
              className="notificationModal1CloseButton"
              onClick={onClose}
            >
              <img src={CrossIcon} alt="Close" />
            </IconButton>
          </Box>

        {selectedType1==="Notification" && (
              <ImageUploader
              data="Upload Your Image"
              onUpload={handleImageUpload}
              setPicture={setPicture}
              picture={picture}
              />
            )
        }

          <Box className="notificationModal1FormContainer">
            <Box className="notificationModal1FieldsContainer">
              <Box className="notificationModal1Field">
                <InputLabel
                  htmlFor="dropdown"
                  className="notificationModal1InputLabel"
                >
                  Select Send to
                </InputLabel>
                <FormControl fullWidth>
                  <Select
                    id="dropdown"
                    value={sendTo === 1 ? "User" : "Sellers"}
                    onChange={handleSendToChange}
                    className="notificationModal1Select"
                  >
                    <MenuItem value="User">User</MenuItem>
                    <MenuItem value="Sellers">Vender</MenuItem>
                  </Select>
                </FormControl>
              </Box>

              <Box className="notificationModal1Field">
                <InputLabel
                  htmlFor="date-picker"
                  className="notificationModal1InputLabel"
                >
                  Notification Date
                </InputLabel>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    // minDate={new Date()}
                   disablePast
                    id="date-picker"
                    value={notificationDate}
                    onChange={(newValue) => setNotificationDate(newValue)}
                    renderInput={(params) => (
                      <input
                        type="text"
                        {...params.inputProps}
                        className="notificationModal1DateInput"
                        sx={{
                          borderRadius: "28px !important", 
                        }}
                      />
                    )}
                  />
                </LocalizationProvider>
              </Box>

              <Box className="notificationModal1Field">
                <InputLabel
                  htmlFor="time-picker"
                  className="notificationModal1InputLabel"
                >
                  Enter Time
                </InputLabel>
                <input
                  id="time-picker"
                  type="time"
                  value={time}
                  onChange={(e) => {
                    const inputValue = e.target.value;
                    const formattedTime = inputValue ? `${inputValue}:00` : "";
                    setTime(formattedTime);
                  }}
                  className="notificationModal1TimeInput"
                />
              </Box>
            </Box>
          </Box>

          <Box className="notificationModal1TypeSelectionContainer">
            <div className="notificationModal1TypeLabel">
              Type of Notification
            </div>
            <FormControl
              component="fieldset"
              className="notificationModal1RadioGroupContainer"
            >
              <RadioGroup
                value={selectedType1}
                onChange={(e) => setSelectedType1(e.target.value)}
                row
              >
                <FormControlLabel
                  value="Notification"
                  control={<Radio className="notificationModal1Radio" />}
                  label="Notification"
                />
                <FormControlLabel
                  value="Email"
                  control={<Radio className="notificationModal1Radio" />}
                  label="Email"
                />
              </RadioGroup>
            </FormControl>
          </Box>

          {selectedType1 === "Email" ? (
  <>
    {/* ReactQuill for Email Content */}
    <ReactQuill
      theme="snow"
      value={value}
      onChange={(content) => {
        setValue(content);
      }}
      className="notificationModal1EmailEditor"
    />
  </>
) : (
  <>
    {/* Notification Type - Title & Description Fields */}
    <div className="notificationModal1InputContainer">
      <label className="notificationModal1InputLabel">Notification Title</label>
      <input
        type="text"
        placeholder="Enter title"
        value={title}
        onChange={(e) => {
          if (e.target.value.trim() !== "" || e.target.value === "") {
            setTitle(e.target.value);
          }
        }}
        className="notificationModal1Input"
      />
    </div>

    <div className="notificationModal1InputContainer">
      <label className="notificationModal1InputLabel">Description</label>
      <textarea
        placeholder="Enter Description"
        value={description}
        // onChange={(e) => setDescription(e.target.value)}
        onChange={(e) => {
          if (e.target.value.trim() !== "" || e.target.value === "") {
            setDescription(e.target.value);
          }
        }}
        rows={4}
        className="notificationModal1Textarea"
      />
    </div>
  </>
)}


          <Box className="notificationModal1RadioContainer">
            <div className="notificationModal1RadioLabel">
              Send Notification
            </div>

            <FormControl
              component="fieldset"
              className="notificationModal1RadioGroup"
            >
              <RadioGroup
                value={selectedType}
                onChange={(e) => setSelectedType(e.target.value)}
                row
              >
                <FormControlLabel
                  value={`All Users`}
                  control={<Radio className="notificationModal1RadioButton" />}
                  label={`To all ${sendTo === 1 ? "Users" : "Vendors"}`}
                />

                <FormControlLabel
                  value={`Selected Users`}
                  control={<Radio className="notificationModal1RadioButton" />}
                  label={`To Selected ${sendTo === 1 ? "User" : "Vendor"}`} 
                />
              </RadioGroup>
            </FormControl>
          </Box>

          {selectedType === `Selected Users` && (
            <Box className="notificationModal1UserBox">
              <Box className="notificationModal1UserDetails">
                {/* Avatar group displaying the first 4 users */}
                <AvatarGroup
                  total={totalUser}
                  className="notificationModal1AvatarGroup"
                >
                  {userList.map((user, index) => (
                    <Avatar
                      key={index}
                      alt={user?.fullname}
                      src={
                        user?.picture
                          ? `${configuration.cdnFront}/${user.picture}`
                          : UserImg
                      }
                      className="notificationModal1Avatar"
                    />
                  ))}
                </AvatarGroup>

                {/* Display total attendance */}
                {/* <Typography className="notificationModal1AttendanceText">
          {totalUser} Users
        </Typography> */}
              </Box>
              <Button
                className="notificationModal1SelectUserButton"
                onClick={handleSelectUserModal}
              >
                 Add {sendTo === 1 ? "User" : "Vendor"}
              </Button>
            </Box>
          )}

          <Box className="notificationModal1ButtonContainer">
            <Button
              variant="contained"
              onClick={handleSave}
              className="notificationModal1SaveButton"
            >
            {editingData ? "Edit Notification" : "Create New Notification"}
            </Button>
          </Box>
        </Box>
      </Modal>

      <Modal
        open={selctUserModal}
        onClose={handleCloseSelectedUserModal}
        className="secondModal"
      >
        <Box className="secondModal-box">
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <Typography id="modal-title" className="secondModal-title notificationModal1Title">
            {`Add ${sendTo === 1 ? "Users" : "Vendors"}`}
            </Typography>
            <IconButton
              onClick={handleCloseSelectedUserModal}
              className="secondModal-closeButton"
            >
              <img src={CrossIcon} alt="Close" />
            </IconButton>
          </Box>

          <Box mt={3}>
    <TextField
        value={searchQuery}
        onChange={(e) => {
          if (e.target.value.trim() !== "" || e.target.value === "") {
            setSearchQuery(e.target.value);
          }
        }}
        placeholder={`Search by ${sendTo === 1 ? "Users" : "Vendors"} name`}
        sx={{
            width: "100%",
            height: { xs: 52, sm: 58 },
            flexShrink: 0,
            borderRadius: "33px",
            background: "#EBEBEB",
            border: "none",
            "& .MuiOutlinedInput-root": {
                borderRadius: "33px",
                height: "100%",
                paddingLeft: "25px",
                paddingRight: "10px",
                outline: "none",
                border: "none",
            },
            "& .MuiOutlinedInput-notchedOutline": {
                border: "none",
            },
        }}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <img
                src={SearchItem}
                sx={{ color: "#000", opacity: "0.35" }}
              />
            </InputAdornment>
          ),
          style: { height: "100%" },
        }}
    />
</Box>

{/* Render user list */}
{userList?.map((user) => (
    <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mt={3}
        key={user._id}
    >
        {/* User Info */}
        <Box display="flex" alignItems="center">
            <Avatar
                src={
                    user?.picture
                        ? `${configuration.cdnFront}/${user.picture}`
                        : UserImg
                }
                alt={user?.fullname || "User"}
                sx={{ width: 40, height: 40 }}
            />
            <Typography sx={{ marginLeft: "10px" }}>
                {user?.fullname || "N/A"}
            </Typography>
        </Box>

        {/* Select/Remove Button */}
                <Button
          variant="contained"
          sx={{
            backgroundColor: selectedIds.includes(user?._id) ? "#EA001B" : "#0D7B5C",
            borderRadius: '28px',
            textTransform: 'none',
            width: '94px',
            height: "41px",
            "&:hover": {
              backgroundColor: selectedIds.includes(user?._id) ? "#EA001B" : "#0D7B5C", 
              boxShadow: "none",
            }
          }}
          onClick={() => toggleUserSelection(user?._id)}
        >
          {selectedIds.includes(user?._id) ? "UnSelect" : "Select"}
        </Button>
    </Box>
))}

          <div style={{display:'flex',justifyContent:'center'}}>

          <Paginations
            totalPages={totalPages}
            currentPage={currentPage}
            onPageChange={handlePageChange}
            disabled={loading}
          />
          </div>

          {/* Add Users Button */}
          <Box display="flex" justifyContent="center" mt={5}>
          <CustomBtn text="Add" onClick={handleAddUsers} />
          </Box>
        </Box>
      </Modal>
    </>
  );
};

export default NotificationModal;
